import { lazy, Suspense, type FC } from 'react';
import { type DesignDirectoryProps } from '../DesignDirectoryTypes.ts';

const DesignsDirectoryQuickJump = lazy(
    () =>
        import(
            /* webpackChunkName: "DesignsDirectoryQuickJump" */ './DesignsDirectoryQuickJump.tsx'
        )
);

export const DesignsDirectoryQuickJumpLazy: FC<DesignDirectoryProps> = props => (
    <Suspense fallback="">
        <DesignsDirectoryQuickJump {...props} />
    </Suspense>
);
